<template>
  <swiper-table
    title="政策资讯"
    :contentMode="ContentMode" />
</template>

<script>
import SwiperTable from './busi/swiper-table.vue'
import { ContentMode } from '../../utils/index'
export default {
  name: 'NewsList',
  components: { SwiperTable },
  data() {
    return {
      ContentMode: ContentMode.filter(i => [0, 1].indexOf(i.value) > -1)
    }
  }
}
</script>

